export const pluginID = 'tax-free-from-plugin';
export type Configuration = {
  minPurchaseAmount?: string;
};
